import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import updatePageNumber from '~/helpers/pagination-helper';

const MdmLoader = () => import(
/* webpackChunkName: "mdm-loader" */
'~/components/atoms/Global/MdmLoader.vue');

export default {
  name: 'MdmInfiniteScroll',
  components: {
    MdmLoader
  },
  props: {
    total: {
      type: Number,
      default: 3
    },
    from: {
      type: Number,
      default: 0
    },
    nextPage: {
      type: Number,
      default: 1
    },
    previousPage: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 40
    },
    progressMsg: {
      type: String,
      default: ''
    },
    buttonMsg: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    bottom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tracking() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Clic_plus de produits',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },

    hasMoreItems() {
      return this.total - this.from > 0;
    },

    percent() {
      const percent = this.from < this.total ? Math.floor(this.from / this.total * 100) : 100;
      return {
        height: '5px',
        width: "".concat(percent, "%"),
        background: '#c4a181'
      };
    }

  },
  methods: _objectSpread({}, mapMutations({
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE'
  }), {
    previous() {
      this.setPreviousPage(this.previousPage - 1);
      updatePageNumber(this.previousPage - 1);
    },

    next() {
      this.setNextPage(this.nextPage + 1);
      updatePageNumber(this.nextPage + 1);
    }

  })
};